// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"K8-z","button":"L8-z","disabled":"M8-z","creditCard":"N8-z","wrapper":"O8-z"};